<mat-card>
  <mat-card-header>
    <mat-card-title><a [routerLink]="linkRouterParams" [appTooltip]="tooltip">{{title}}</a></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="data.length > 0; else noValue" class="property-field-group">
      <div *ngFor="let d of data" class="property-field-container col-12 col-md-6 col-xl-4">
        <div class="property-field">
          <span class="property-field-title">{{ d.title }}</span><span class="property-field-value">{{ d.value }}</span>
        </div>
      </div>
    </div>
    <ng-template #noValue>
      <span class="no-content">
        <p>{{ noContent }}</p>
        <p *ngIf="noContent2">{{ noContent2 }}</p>
      </span>
    </ng-template>
  </mat-card-content>
</mat-card>
